export interface BreadcrumbItem {
    label: string;
    href?: string;
    active?: boolean;
}

export interface PageHeaderProps {
    title: string;
    breadcrumbs?: BreadcrumbItem[];
    className?: string;
    titleClassName?: string;
}

const PageHeader = ({
    title,
    breadcrumbs = [],
    className = '',
    titleClassName = 'page-title fw-semibold fs-18 mb-0',
}: PageHeaderProps) => {
    return (
        <div
            className={`d-md-flex d-block align-items-center justify-content-between page-header-breadcrumb ${className}`}
        >
            <h1 className={titleClassName}>{title}</h1>
            {breadcrumbs.length > 0 && (
                <div className="ms-md-1 ms-0">
                    <nav>
                        <ol className="breadcrumb mb-0">
                            {breadcrumbs.map((item, index) => (
                                <li
                                    key={index}
                                    className={`breadcrumb-item ${item.active ? 'active' : ''}`}
                                    {...(item.active && {
                                        'aria-current': 'page',
                                    })}
                                >
                                    {item.href && !item.active ? (
                                        <a href={item.href}>{item.label}</a>
                                    ) : (
                                        item.label
                                    )}
                                </li>
                            ))}
                        </ol>
                    </nav>
                </div>
            )}
        </div>
    );
};

export default PageHeader;
